import * as React from 'react';
import { Button, Image } from 'semantic-ui-react';

export interface LoginButtonProps {
  provider: string;
  initiateAuthRequest(provider: string): void;
  initiatePopupCloseRequest(): void;
}

export class LoginButton extends React.Component<LoginButtonProps, {}> {

  componentDidMount() {
    if (window.location.href.includes('auth')) {
      this.props.initiatePopupCloseRequest();
    }
  }

  handleLoginClick = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    this.props.initiateAuthRequest(this.props.provider);
  }

  render() {
    const { provider } = this.props;
    return (
      <Button 
        circular={true}
        onClick={this.handleLoginClick}
        basic={true}
        id={provider}
      >
        <Image spaced="right" inline={true} src={`../../images/${provider}-logo.svg`} />
        Login with {provider}
      </Button>
    );
  }
}







// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Login/LoginButton.tsx